import { messageNoUsername } from 'constants/messages';
import { IUserResource } from '../../server/types';

const getUserName = (user: Partial<IUserResource>) => {
  const name = user?.firstName || user?.lastName ? `${user.firstName ?? ''} ${user.lastName ?? ''}` : messageNoUsername;

  return name.trim();
};

export { getUserName };
